<template>
    <div class="wrap">
        <div class="head">
           <Banner></Banner>
        </div>
        <div class="content">
            <div class="content-wrap">
                <label @click="toInfo">{{btn_1}}</label>
                <label @click="toJudge">{{btn_3}}</label>
                <label @click="toSearch(1)">{{btn_2}}</label>
                <label @click="toSearch(2)">{{btn_4}}</label>
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    export default {
        name: "RepToken",
        components:{
            Banner
        },
        data(){
            return{
                btn_1:"提交医生名单",
                btn_3:"提交评委名单",
                btn_2:"查询医生进展",
                btn_4:"查询评委进展",
                repOpenid:this.$route.query.repOpenid
            }
        },
        methods:{
            toInfo(){
                this.$router.push({path:"repInfo",query:{repOpenid:this.repOpenid}})
            },
            toSearch(type){
                this.$router.push({path:"repSearch",query:{type:type}})
            },
            toJudge(){
                this.$router.push("judgeInfo")
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
    }
    .content{
        flex-grow: 1;
    }
    .head{
        width: 100%;
        /*height: 300px;*/
    }
    .head .logo{
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin: 10px 0;
        .logo_1{
            width: 30px;
            height: 30px;
            margin-left: 20px;
        }
        .logo_2{
            width: 90px;
            height: 30px;
            margin-right: 20px;
        }
    }
    .kv{
        width: 100%;
        height: 180px;
        display: flex;
        justify-content: center;
        img{
            width: 275px;
            height: 157px;
        }
    }
    .bottom{
        flex-grow: 1;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        img{
            width: 70%;
            object-fit: contain;
        }
    }
    .content{
        /*background: red;*/
    }
    .content-wrap{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        label{
            border: #2c9a58 1px solid;
            width: 80%;
            height: 30px;
            line-height: 30px;
            color: #2c9a58;
            font-weight: bold;
            font-size: 16px;
            border-radius: 5px;
            margin-top: 20px;
        }
    }
    input:focus{
        border: none;
    }

</style>